var url_parameters = new URLSearchParams(window.location.search);

function change_section(e) {
	var button_id = e.currentTarget.id;

	document.querySelectorAll('[data-display]').forEach( function(x) {
		x.hidden = x.dataset.display !== button_id;

		if (x.tagName.toLowerCase() === 'fieldset') x.disabled = x.hidden;
	} );

	document.querySelectorAll('.button_group button').forEach( function(x) {
		x.classList.remove('active');

		if (x.id === button_id) x.classList.add('active');
	} );

	document.querySelector('input[name = "category"]').value = button_id;
}


// ...

if (url_parameters.get('sent') === 'yes') document.querySelector('.feedback.success').hidden = false;

document.querySelectorAll('.button_group button').forEach( function(x) {
	x.addEventListener('click', change_section);
} );